import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class WidgetService {

  private baseUrl = `${environment.widgetUrl}/Dashboard`;
  private headers = new HttpHeaders({ "Content-Type": "application/json" });
  private headersCsv = new HttpHeaders({ "Content-Type": "application/json" });

  constructor(
    private http: HttpClient
  ) { }

  getAll() {
    return this.http
      .get<any>(this.baseUrl + '/WidgetsList', { headers: this.headers, observe: 'response' })
      .toPromise();
  }

  getByPerson(id) {
    return this.http
      .get<any>(this.baseUrl + `/WidgetsList/GetWidgetsPerson/${id}`, { headers: this.headers, observe: 'response' })
      .toPromise();
  }

  getWidgetsInsurance(id, insurance, start, end) {
    return this.http
      .get<any>(this.baseUrl + `/GetWidgets/${id}/insurance/${insurance}/filterDate/${start}/${end}`, { headers: this.headers, observe: 'response' })
      .toPromise();
  }

  getWidgetsProvider(id, insurance, provider, start, end) {
    return this.http
      .get<any>(this.baseUrl + `/GetWidgets/${id}/insurance/${provider}/provider/${insurance}/filterDate/${start}/${end}`, { headers: this.headers, observe: 'response' })
      .toPromise();
  }

  saveWidget(body) {
    return this.http
      .post<any>(this.baseUrl + '/GetWidgets/WidgetPerson/Create', body, { headers: this.headers, observe: 'response' })
      .pipe(
        tap(res => {
        })
      ).toPromise();
  }

  deleteWidget(personId, WidgetsId) {
    return this.http
      .delete<any>(this.baseUrl + `/GetWidgets/WidgetPerson/Delite/${personId}/${WidgetsId}`, { headers: this.headers, observe: 'response' })
      .toPromise();
  }

  getAnalytics(widgetsId, insurance, start, end, regionId?, fileType?) {
    return this.http
      .get(this.baseUrl + `/GetAnalytics/insurance/${widgetsId}/${insurance}/filterDate/${start}/${end}?regionId=${regionId}&type=${fileType}`, { headers: this.headers, observe: 'response', responseType: 'blob' })
      .toPromise();
  }

  getAnalyticsV2(obj: any) {
    return this.http
      .get(this.baseUrl + `/GetAnalyticsV2/insurance/${obj.widgetId}/${obj.insuranceId}/filterDate/${obj.dateStart}/${obj.dateEnd}?providerId=${obj.providerId}&regionId=${obj.regionId}&fileType=${obj.type}&email=${obj.email}&name=${obj.fullName}`, { headers: this.headers, observe: 'response', responseType: 'blob' })
      .toPromise();
  }

  getAnalyticsProvider(widgetsId, insurance, start, end, provider, regionId?, fileType?) {
    return this.http
      .get(this.baseUrl + `/GetAnalytics/insurance/${widgetsId}/${insurance}/filterDate/${start}/${end}?providerId=${provider}&regionId=${regionId}&fileType=${fileType}`, { headers: this.headers, observe: 'response', responseType: 'blob' })
      .toPromise();
  }

  getLazyProcessReportsAnalyticsInfo(userId) {
    return this.http
      .get<any>(this.baseUrl + `/LazyReportProcess/${userId}`, { headers: this.headers, observe: 'response' })
      .toPromise();
  }

  createLazyReportProcess(lazyRepBody) {
    return this.http
      .post<any>(this.baseUrl + '/LazyReportProcess', lazyRepBody, { headers: this.headers, observe: 'response' })
      .pipe(
        tap(res => {
        })
      ).toPromise();
  }

  removeLazyReportProcess(processId, idPerson) {
    return this.http
      .delete<any>(this.baseUrl + `/RemoveLazyReportProcess/${processId}/${idPerson}`, { headers: this.headers, observe: 'response' })
      .toPromise();
  }

  setDownloadedLazyReportProcess(processId, idPerson) {
    return this.http
      .put<any>(this.baseUrl + `/SetDownloadedLazyReportProcess/${processId}/${idPerson}`, { headers: this.headers, observe: 'response' })
      .toPromise();
  }
}
